<script lang="ts" setup>
type ParagraphVariant =
  | "solid"
  | "soft"
  | "outline"
  | "subtle"
  | "ghost"
  | "link";

interface ParagraphProps {
  variant?: ParagraphVariant;
}

const props = withDefaults(defineProps<ParagraphProps>(), { variant: "solid" });

const variantClass = {
  solid: "text-gray-700 dark:text-primary-100",
  soft: "text-gray-500 dark:text-gray-400",
  outline: "text-gray-600 dark:text-gray-300",
  subtle: "text-gray-400 dark:text-gray-500",
  ghost: "text-gray-300 dark:text-gray-600",
  link: "text-primary-600 dark:text-primary-400",
};
</script>
<template>
  <p :class="['text-base', variantClass[props.variant]]">
    <slot />
  </p>
</template>
